// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"da794fe3","377":"70b33f08","703":"97ca9ad7"}[chunkId] + ".chunk.js";
};